export function getFlatsErrorTitle(hasFlatsFromAgents: boolean, isHouseSelected: boolean): string {
  const basicText = hasFlatsFromAgents ? 'Нет предложений от застройщика' : 'Нет предложений';
  const additionalText = isHouseSelected ? 'в этом корпусе' : 'в этом ЖК';

  return `${basicText} ${additionalText}`;
}
